<!-- =========================================================================================
  File Name: TimeWindowCreate.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" id="wizard-with-loading-optimization" class="tabs-container vs-con-loading__container">
		<floating-buttons
			style="left: 63.2px"
			:titleHeader="$t('BreakTable.Action')"
			:cancelText="$t('Cancel')"
			:saveText="$t('Routing.Buttons.Reoptimize')"
			@save="showPrompt"
			@cancel="$router.push({name: 'OptimizationList'})"
		/>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vs-navbar :type="'gradient'" v-model="activeItem" class="nabarx mt-base mb-4">
					<div slot="title">
						<vs-navbar-title class="flex items-cemter">
							<span class="text-primary font-bold ml-4 mt-2">{{ getNameOptimization }} </span>
						</vs-navbar-title>
					</div>
					<vs-navbar-item index="0">
						<a href="#" class="text-center"
							><feather-icon class="cursor-pointer" icon="MapPinIcon" /><br /><small
								style="font-size: 0.9rem"
								class="font-semibold"
								>{{
									activeItem === "0"
										? $t("RouterSelection.VisitPoints")
										: $t("See") + " " + $t("RouterSelection.VisitPoints")
								}}</small
							></a
						>
					</vs-navbar-item>
					<vs-navbar-item index="1">
						<a href="#" class="text-center"
							><feather-icon class="cursor-pointer" icon="UsersIcon" /><br /><small
								style="font-size: 0.9rem"
								class="font-semibold"
								>{{
									activeItem === "1"
										? $t("Vehicles.Vehicles")
										: $t("See") + " " + $t("Vehicles.Vehicles")
								}}</small
							></a
						>
					</vs-navbar-item>
					<vs-navbar-item index="2">
						<a href="#" class="text-center"
							><feather-icon class="cursor-pointer" icon="LinkIcon" /><br /><small
								style="font-size: 0.9rem"
								class="font-semibold"
								>{{
									activeItem === "2"
										? $t("Jobs.JobPlanning")
										: $t("See") + " " + $t("Jobs.JobPlanning")
								}}</small
							></a
						>
					</vs-navbar-item>
				</vs-navbar>
				<transition name="fade">
					<ListSelectedVisitPoints
						v-if="activeItem === '0' && activeTabVisitPoint"
						ref="ListSelectedVisitPoint"
						:activeTabVisitPoint="activeTabVisitPoint"
						@initMapOptimizationEmit="initMapOptimization"
					/>
				</transition>
				<transition name="fade">
					<list-select-vehicle v-if="activeItem === '1' && activeTabResource" ref="ListSelectedVehicle" />
				</transition>
				<transition name="fade">
					<job-planning-form v-if="activeItem === '2'" />
				</transition>
			</div>
		</div>
		<vs-popup :fullscreen="true" :title="null" :active.sync="resourceMounted" class="vs-popup--content-custom">
			<div class="is-stuck mt-10" style="background: white">
				<vx-card no-shadow card-border>
					<div class="form-header-inner flex justify-between items-center">
						<vs-input
							class="sm:mr-4 mr-0 sm:w-1/3 w-full sm:order-normal order-3 sm:mt-0 mt-4"
							v-model="searchQuery"
							@input="updateSearchQuery($event)"
							:placeholder="this.$t('ResourceModule.Table.Search')"
						/>
						<vs-button
							:size="iconSize"
							class="ml-2"
							icon-pack="feather"
							icon="icon-check"
							:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
							:disabled="getCheckedVehicles.length <= 0"
							@click.prevent="setAssignedResource"
							>{{
								windowWidth > 620 ? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection") : null
							}}
						</vs-button>
					</div>
				</vx-card>
			</div>
			<vehicle-list
				ref="VehicleListPopup"
				style="margin-top: 70px"
				:componentParent="'OPTIMIZATION'"
				:customConfig="vehicleListConfig"
			/>
		</vs-popup>
		<vs-prompt
			class="prompt-content"
			:title="$t('Optimization.CreateOptimization')"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			:is-valid="validFormPrompt"
			@cancel="closePrompt"
			@accept="acceptPrompt"
			@close="closePrompt"
		>
			<optimization-create
				:isReoptimize="true"
				:optimizationObject="dataOptimization"
				@OptimizationFields="optimizationFields"
			/>
		</vs-prompt>
		<vs-prompt
			class="prompt-content"
			:title="$t('Frequency.DiscardedItems.Title')"
			:active.sync="activeDiscardedItemsPrompt"
			:cancelText="$t('Routing.Title.Close')"
			:buttons-hidden="true"
			@cancel="closeDiscardedItemsPrompt"
			@close="closeDiscardedItemsPrompt"
		>
			<div class="text-left">
				<p>{{ $t("Frequency.DiscardedItems.Message") }}</p>
				<ul class="mt-2 mb-10 pl-4">
					<li v-for="(item, index) in paginatedDiscardedItems" :key="index" class="mb-2">❌ {{ item }}</li>
				</ul>
				<!-- Pagination -->
				<div v-if="showDiscardedItemsPagination" class="mt-2 mb-10 text-center">
					<vs-pagination
						:total="totalDiscardedItemsPages"
						:max="5"
						v-model="currentDiscardedItemsPage"
						@change="changeDiscardedItemsPage"
					/>
				</div>
			</div>
		</vs-prompt>
		<optimization-errors
			:errorsActive="errorsActive"
			:optimizationErrors="optimizationErrors"
			@activePopupEmit="activePopup"
		/>
	</div>
</template>

<script>
import {ReOptimizationEditMixin} from "../model/ReOptimizationEditMixin.js";

export default {
	mixins: [ReOptimizationEditMixin],
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 550px;
	max-height: 500px;
}

.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.is-stuck {
	position: fixed;
	top: 12px;
	inset-inline-start: 0;
	margin-inline-start: 16px;
	width: calc(100% - 38px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
